/**
 * Human-friendly countdown label for an event date (YYYY-MM-DD), relative to
 * today in local time. Returns a short string like "Today", "Tomorrow",
 * "This weekend", "in 5 days", "in 3 weeks", or undefined for past dates.
 */
export function countdownLabel(startDate: string, now = new Date()): string | undefined {
  const d = new Date(`${startDate}T00:00:00`);
  if (Number.isNaN(d.getTime())) return undefined;
  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const target = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const days = Math.round((target.getTime() - start.getTime()) / 86_400_000);

  if (days < 0) return undefined;
  if (days === 0) return "Today";
  if (days === 1) return "Tomorrow";

  // "This weekend" if the event is Sat/Sun within the next 6 days.
  const dow = target.getDay(); // 0 Sun .. 6 Sat
  if (days <= 6 && (dow === 6 || dow === 0)) return "This weekend";

  if (days < 7) return `in ${days} days`;
  if (days < 14) return "in 1 week";
  if (days < 28) return `in ${Math.round(days / 7)} weeks`;
  const months = Math.round(days / 30);
  return months <= 1 ? "in ~1 month" : `in ~${months} months`;
}

/** Urgency tier for styling the countdown chip. */
export function countdownTier(startDate: string, now = new Date()): "soon" | "near" | "far" {
  const d = new Date(`${startDate}T00:00:00`);
  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const target = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const days = Math.round((target.getTime() - start.getTime()) / 86_400_000);
  if (days <= 3) return "soon";
  if (days <= 10) return "near";
  return "far";
}
